module.exports = __webpack_public_path__ + "static/img/gongan.d0289dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gongan.png
// module id = e4Lp
// module chunks = 13